export default __webpack_public_path__ + "static/media/spiral.f05d6c62.png";